import { lazyOnSupportPaneClose } from 'diagnostics-and-support';
import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import loc from 'owa-localize';
import {
    editorPaneHeader,
    helpPaneHeader,
    tipsPaneHeader,
} from '../components/AppPaneGroup.locstring.json';
import { rolloutOverridesBody, tipsBody } from '../components/AppPaneGroup.scss';
import type { AppPaneConfig } from '../types/AppPaneConfig';

import { DictationHelpPane as LazyDictationHelpPane } from 'owa-editor-dictation';
import { DexPaneWrapper as LazyDexPaneWrapper } from 'owa-editor-proofing-dex-pane';
import { RolloutOverridesPane as LazyRolloutOverridesPane } from 'owa-header-pane';
import { WhatsNewFluentPane as LazyWhatsNewFluentPane } from 'owa-whats-new';

export const appPanesConfiguration: ReadonlyArray<AppPaneConfig> = [
    // Panes that are rendered as part of the AppPaneGroup
    {
        paneId: getDrawerPaneId('editor'),
        getHeaderText: () => loc(editorPaneHeader),
        getChildren: () => <LazyDexPaneWrapper />,
    },
    {
        paneId: getDrawerPaneId('help'),
        getHeaderText: () => loc(helpPaneHeader),
        getChildren: () => <>The help section is currently being developed. 🚧</>,
    },
    {
        paneId: getDrawerPaneId('rolloutOverrides'),
        getHeaderText: () => 'Rollout Overrides',
        getChildren: () => <LazyRolloutOverridesPane />,
        bodyClassName: rolloutOverridesBody,
    },
    {
        paneId: getDrawerPaneId('tips'),
        getHeaderText: () => loc(tipsPaneHeader),
        getChildren: () => <LazyWhatsNewFluentPane />,
        bodyClassName: tipsBody,
    },
    {
        paneId: getDrawerPaneId('dictationHelp'),
        getHeaderText: () => loc(helpPaneHeader),
        getChildren: () => <LazyDictationHelpPane />,
    },

    // Standalone panes that are rendered separately
    {
        paneId: getDrawerPaneId('addins'),
        isStandaloneComponent: true,
    },
    {
        paneId: getDrawerPaneId('chatCopilot'),
        isStandaloneComponent: true,
    },
    {
        paneId: getDrawerPaneId('feedback'),
        isStandaloneComponent: true,
    },
    {
        paneId: getDrawerPaneId('getDiagnostics'),
        isStandaloneComponent: true,
    },
    {
        paneId: getDrawerPaneId('support'),
        isStandaloneComponent: true,
        onDismiss: () => {
            lazyOnSupportPaneClose.importAndExecute();
        },
    },
] as const;
